const moduleMap = {
	"./CollectionResource": () => {
		return Promise.all([__webpack_require__.e(303), __webpack_require__.e(968), __webpack_require__.e(354), __webpack_require__.e(543), __webpack_require__.e(129), __webpack_require__.e(918), __webpack_require__.e(579), __webpack_require__.e(326), __webpack_require__.e(10), __webpack_require__.e(157), __webpack_require__.e(342), __webpack_require__.e(146), __webpack_require__.e(265), __webpack_require__.e(606), __webpack_require__.e(75), __webpack_require__.e(719)]).then(() => (() => ((__webpack_require__(94719)))));
	},
	"./CollectionNavigation": () => {
		return Promise.all([__webpack_require__.e(326), __webpack_require__.e(741)]).then(() => (() => ((__webpack_require__(741)))));
	},
	"./collectionCore": () => {
		return Promise.all([__webpack_require__.e(303), __webpack_require__.e(968), __webpack_require__.e(354), __webpack_require__.e(543), __webpack_require__.e(129), __webpack_require__.e(918), __webpack_require__.e(579), __webpack_require__.e(537), __webpack_require__.e(326), __webpack_require__.e(10), __webpack_require__.e(157), __webpack_require__.e(342), __webpack_require__.e(146), __webpack_require__.e(265), __webpack_require__.e(606), __webpack_require__.e(75), __webpack_require__.e(34)]).then(() => (() => ((__webpack_require__(78034)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});